export default {
  detailsMinZoomLevel: 14,
  detailsMinZoomLevelNavAids: 13,
  detailsMinZoomLevelBoaters: 8,
  detailsMinZoomLevelTideAndCurrents: 12,
  bridgesAlertsMinZoomLvl: 12,
  noaaHazardsMinZoomLvl: 15,
};
